import * as fileStackStuff from './fileStack';
import './imageViewer';
import intense from './intense';
import './jquery.dotdotdot';
import './redactorPlugins';
import bowser from './bowser.min';
import webcam from './webcam.min';

window.Intense = intense;
window.Webcam = webcam;
window.bowser = bowser;
window.filestack = fileStackStuff;
